import apiFetch from '../apiFetch'

export default function (rutasAnadidas, token) {
  return apiFetch({endPoint: `Transportista/filtrarRuta`, method: 'POST', body: rutasAnadidas, token: token})
}